import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: _ctx.active,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.active) = $event)),
    "close-on-content-click": false,
    location: "bottom"
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _mergeProps(props, { class: "ios-click-barrier" }), [
        _createVNode(_component_v_text_field, _mergeProps({
          class: "_v-digital-time-picker pointer-events-none",
          readonly: "",
          "model-value": _ctx.modelValue
        }, _ctx.$attrs, { tabindex: "-1" }), null, 16, ["model-value"])
      ], 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "d-flex align-center pa-2",
        style: {"width":"300px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_select, {
            "append-icon": "",
            class: "_v-digital-time-picker__select pt-0 mt-0 align-center",
            "hide-details": "",
            items: _ctx.hourOptions,
            variant: "outlined",
            density: "compact",
            "model-value": _ctx.hourValue,
            autocomplete: "new-password",
            name: "dummy-hour",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeValue($event, 'hour')))
          }, null, 8, ["items", "model-value"]),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "_v-digital-time-picker__comma mx-1 font-weight-bold" }, " : ", -1)),
          _createVNode(_component_v_select, {
            "append-icon": "",
            class: "_v-digital-time-picker__select pt-0 mt-0 align-center",
            "hide-details": "",
            items: _ctx.minutesOptions,
            variant: "outlined",
            density: "compact",
            "model-value": _ctx.minuteValue,
            autocomplete: "new-password",
            name: "dummy-minute",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeValue($event, 'minute')))
          }, null, 8, ["items", "model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}